import React from 'react';
import WizardParticipantsTable from './WizardParticipantsTable';

export default class WizardStep1 extends React.Component {

    render() {
        return (
            <div className="wizard-step-1">
                {(!this.props.removedParticipants.length && !this.props.updatedParticipants.length)
                    ? <span className="double-line-height">No participants have been updated or removed.  <br /> Click Next to continue.</span> :
                    <div>
                        {this.props.removedParticipants.length > 0 && <div className="modal-section">
                            <p className="error-text medium-text"><i className="icon-close icon-left"></i>The following recipients were removed from this list</p>
                            <WizardParticipantsTable
                                isOrgList={this.props.isOrgList}
                                isIsraeli={this.props.isIsraeli}
                                participants={this.props.removedParticipants}
                            />
                        </div>}

                        {this.props.updatedParticipants.length > 0 && <div className="modal-section">
                            <p className="approved-text medium-text"><i className="icon-check icon-left"></i>The following recipients have been updated</p>
                            <WizardParticipantsTable
                                isOrgList={this.props.isOrgList}
                                isIsraeli={this.props.isIsraeli}
                                participants={this.props.updatedParticipants}
                            />
                        </div>}
                    </div>}
                <div className="modal-btns text-right">
                    <button className="btn btn-accent" onClick={this.props.close}>Cancel</button>
                    <button className="btn btn-primary" onClick={this.props.next}>Next</button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/VerifyCampaignListWizard/WizardStep1.jsx